'use client';

import Section from '../molecules/section';
import { useTranslations } from 'next-intl';

interface TeamMember {
  name: string;
  title: string;
}

const CreditsSection = () => {
  const t = useTranslations('credits');
  const team = t.raw('team') as TeamMember[];

  return (
    <Section
      id="credits"
      backgroundImage="/images/FAQ.avif"
      className="relative flex min-h-screen items-center justify-center bg-cover bg-no-repeat"
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black opacity-50"></div>

      {/* Top gradient */}
      <div className="absolute inset-x-0 top-0 h-64 bg-gradient-to-b from-black to-transparent"></div>

      {/* Bottom gradient */}
      <div className="absolute inset-x-0 bottom-0 h-64 bg-gradient-to-t from-black to-transparent"></div>

      <div className="relative px-10 pb-80 pt-44">
        <div className="relative flex flex-col items-center space-y-2 text-center">
          <h2 className="px-4 text-center font-sora text-2xl font-bold leading-tight text-white sm:text-3xl md:text-4xl lg:text-5xl">
            {t('title')}
          </h2>
        </div>
        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {team.map(member => (
            <div
              key={member.name}
              className="rounded-lg bg-gray-800/50 p-4 transition-all hover:bg-gray-700/50"
            >
              <div className="text-lg font-semibold text-white">{member.name}</div>
              <div className="text-sm text-gray-400">{member.title}</div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default CreditsSection;
